import { render, staticRenderFns } from "./StaffPerformanceTable.vue?vue&type=template&id=6f369084&scoped=true"
import script from "./StaffPerformanceTable.vue?vue&type=script&lang=js"
export * from "./StaffPerformanceTable.vue?vue&type=script&lang=js"
import style0 from "./StaffPerformanceTable.vue?vue&type=style&index=0&id=6f369084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f369084",
  null
  
)

export default component.exports